"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDevelopmentTranslate = void 0;
exports.defaultDevelopmentTranslate = {
    orContactUsToday: 'or contact us today at',
    markeingEmail: 'marketing@okay.com',
    telephone: '2102 0888',
    telephoneFull: '+85221020888',
    nameDeveloper: 'Developer',
    nameNewDevelopments: 'New Developments',
    prev: 'Previous',
    next: 'Next',
    newDevelopmentWith: 'New Development with',
    photos: 'Photos',
    salesBrochures: 'Sales Brochure',
    priceList: 'Price List',
    contactAgent: 'Contact Agent',
    keyDetails: 'Key Details',
    developmentId: 'Property ID',
    district: 'District',
    noOfBlocks: 'No. of Blocks',
    noOfStoreys: 'No. of Storeys',
    totalFlats: 'Total Flats',
    dateOfOccupationPermit: 'Date of Occupation Permit',
    propertySchoolNet: 'Property School Net',
    noOfCarparkingSpace: 'No of Carparking Space',
    storeyHeight: 'Storey Height',
    propertyDocuments: 'Property Documents',
    floorPlans: 'Floor Plans',
    salesArrangement: 'Sales Arrangement',
    registerOfTransactions: 'Register of Transactions',
    deedOfMutual: 'Deed of Mutual Covenant',
    developmentMap: 'Development Map',
    enlargeMap: 'Enlarge Map',
    listingDescription: 'Listing Description',
    amenities: 'Amenities',
    back: 'Back',
    close: 'Close',
    bannerTitle: 'MOUNT POKFULAM',
    propertyDetails: 'PROPERTY DETAILS',
    getInTouch: 'GET IN TOUCH',
    propertyId: 'Property ID',
    noOfUnits: 'No. Of Units',
    tel: 'Tel',
    email: 'Email',
    follow: 'Follow',
    contactUs: 'Contact Us',
    whatsappUs: 'WhatsApp Us',
    photoGallery: 'Photo',
    videoGallery: 'Video',
    mapContainer: 'Map',
    srpeInfo: '<hr/><p>The information provided above was sourced from the Developer\'s designated website for the development project and/or the website of the Sales of First-hand Residential Properties Authority ("website"). </p><p>Our company, along with any senior officer, employee, or agent: <ul><li>Does not create the information or advertisement in whole or in part;</li><li>Is not accountable for the information or advertisement; and</li><li>Does not verify the accuracy of the information or advertisement;</li><li>Does not guarantee that the above information or advertisements will be consistently updated in sync with the websites. </li></ul></p><p>Customers are advised to obtain the latest information directly from the Developer or the Sales of First-hand Residential Properties Authority. </p><p>The purpose of the Register of Transactions of the Development is to provide a member of the public with the transaction information relating to the Development, as set out in the Register of Transactions for understanding the residential property market conditions in Hong Kong. The personal data in the Register of Transactions should not be used for any purpose not related to the specified purpose.</p><p>Address of website designated by the vendor for the development:<a href=\'###developmentOfficialWebsite\' target=\'blank\'>###developmentOfficialWebsite</a></p><p>Sales of First-hand Residential Properties Electronic Platform (“SRPE”):<a href=\'http://srpe.gov.hk\' target=\'blank\'>http://srpe.gov.hk</a></p>',
    seeAllPhotos: 'See All Photos',
    primarySchoolNet: 'Primary School: ',
    secondarySchoolNet: 'Secondary School: ',
    sizeRange: 'Size Range',
    houseSizeRange: 'Houses',
    apartmentSizeRange: 'Apartments',
    noOfApartments: 'No. of Apartments',
    noOfHouses: 'No. of Houses',
    comingSoon: 'Coming Soon',
    download: 'Download',
};
